import { render } from "./New.vue?vue&type=template&id=5bed895c&scoped=true"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"

import "./New.vue?vue&type=style&index=0&id=5bed895c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bed895c"]])

export default __exports__